module.exports = __webpack_public_path__ + "media/images/livro_reclamacoes-37e9ccc20d1632210a278e7161abb9e1.png";